// extracted by mini-css-extract-plugin
export default {"root":"icon-module--root--7334d"};